// blockHandlers.js
// Contains various helper functions for managing props as well as finding specific
// elements and blocks within them

// filters an array of blocks for a given type and Returns the first match by default
// pass `{ returnAllMatchingBlocks: true }` to get all matching blocks.
const filterForBlockType = (
  arrayOfBlocks,
  type,
  options = { returnAllMatchingBlocks: false },
) => {
  const filtered = arrayOfBlocks?.filter(block => block?.type === type);
  return options.returnAllMatchingBlocks ? filtered : filtered?.[0];
};

export default filterForBlockType;
